var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-363 -475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9875 15 9.65625 2.25C9.375 1.74375 8.64375 1.74375 8.3625 2.25L1.0125 15C0.73125 15.5062 1.0875 16.125 1.66875 16.125L9 16.125 16.3312 16.125C16.9125 16.125 17.2687 15.5062 16.9875 15ZM8.4375 5.25 9.5625 5.25 9.5625 11.8125 8.4375 11.8125 8.4375 5.25ZM9 14.4375C8.475 14.4375 8.0625 14.025 8.0625 13.5 8.0625 12.975 8.475 12.5625 9 12.5625 9.525 12.5625 9.9375 12.975 9.9375 13.5 9.9375 14.025 9.525 14.4375 9 14.4375Z",
    fill: "#70AD47",
    transform: "matrix(1.05556 0 0 1 363 475)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d4821f79ff8eddf9627a09ceb6f43ac1.svg";
export { ForwardRef as ReactComponent };